import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UploadStatus } from 'src/app/services/uploading/enums/upload-status.enum';

@Component({
  selector: 'app-lot-add-photo-uploading-list-item-progress',
  templateUrl: './lot-add-photo-uploading-list-item-progress.component.html',
  styleUrls: ['./lot-add-photo-uploading-list-item-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddPhotoUploadingListItemProgressComponent {
  @Input() status: UploadStatus;
  @Input() uploadingProgress: number;

  get renderSpinner(): boolean {
    const spinnerStatuses = [UploadStatus.initial, UploadStatus.signing];

    return spinnerStatuses.includes(this.status);
  }

  get renderProgress(): boolean {
    return this.status === UploadStatus.uploading;
  }
}
